import {LEAGUES} from "../constants/leagues";

/**
 * Прибавка к росту размера отряда за снабжение у «явных» ботов по их лиге —
 * бонус ботов старших лиг вместо прежних бонусов к костям урона по лиге
 * (кости подкручивает только уровень бонуса «божество», см. getBotD6MinRoll):
 *  - barracks — отряд стоит на работающей казарме;
 *  - other — отряд стоит в любом другом месте.
 * Бронза, серебро и золото прибавки не получают; алмаз — +1 на казарме,
 * рубин и божественная лига — +1 везде.
 *
 * Прибавка ложится на рост за ПЕРВОЕ базовое снабжение отряда в фазе
 * снабжения: великаны получают базовое снабжение сколько угодно раз, но
 * прибавка достается только первому, остальные растят по стандарту (так же
 * устроен бонус военного лагеря). И только там, где отряд вообще растет: d4
 * вне казармы и инсектоиды на пустой ячейке остаются без роста. Потолок
 * размера отряда прежний. См. calcUnitUpdateBasedOnPendingSupply.
 *
 * Числа фиксируются в состоянии игрока на старте матча
 * (player.botSupplySizeBonus): явному боту — сервер по его лиге, боту
 * локальной партии — по лиге-эквиваленту его бонуса (см.
 * prepareLocalMatchPlayers). Рост считает редьюсер и при воспроизведении
 * записи, поэтому старые записи без поля играются по старым правилам, а
 * правка таблицы не переписывает прошлое.
 */
export const BOT_SUPPLY_SIZE_BONUS_BY_LEAGUE = {
  [LEAGUES.DIAMOND]: {barracks: 1, other: 0},
  [LEAGUES.RUBY]: {barracks: 1, other: 1},
  [LEAGUES.GOD]: {barracks: 1, other: 1},
};

// Прибавка лиги для состояния игрока; undefined — лига без прибавки
export const getBotSupplySizeBonusForLeague = (leagueId) => {
  const bonus = BOT_SUPPLY_SIZE_BONUS_BY_LEAGUE[leagueId];
  return bonus ? {...bonus} : undefined;
};

/**
 * Прибавка к росту отряда игрока за снабжение по зафиксированным числам
 * (player.botSupplySizeBonus); 0 — прибавки нет
 *
 * @param {Object} [player] - владелец отряда из состояния партии
 * @param {boolean} isOnWorkingBarracks - стоит ли отряд на работающей казарме
 * @returns {number}
 */
export const getPlayerSupplySizeBonus = (player, isOnWorkingBarracks) => {
  const bonus = player && player.botSupplySizeBonus;
  if (!bonus) {
    return 0;
  }
  return (isOnWorkingBarracks ? bonus.barracks : bonus.other) || 0;
};
